import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  PatientEstimateVerifyRequest,
  PatientEstimateVerifyResponse,
} from '@patient-ui/shared/models';
import { EnvironmentService } from '@patient-ui/shared-ui/utils';

@Injectable({
  providedIn: 'root',
})
export class PatientEstimateService {
  constructor(
    private readonly http: HttpClient,
    private envService: EnvironmentService
  ) {}

  verifyPatientEstimate(
    request: PatientEstimateVerifyRequest
  ): Observable<PatientEstimateVerifyResponse> {
    // Backend API: POST /guest/estimate/{token}/verify
    const url = `${this.envService.baseUrl}/guest/estimate/${request.shortKey}/verify`;

    // Send only DOB and ZIP in request body (token is in URL path)
    // Backend expects 'dob' not 'dateOfBirth'
    const body = {
      dob: request.dateOfBirth,
      zipCode: request.zipCode,
    };

    return this.http.post<PatientEstimateVerifyResponse>(url, body);
  }

  fetchPdfBlob(
    shortKey: string,
    dob: string,
    zipCode: string
  ): Observable<Blob> {
    // Remove any trailing slashes from shortKey to avoid double slashes
    const cleanShortKey = shortKey.replace(/\/+$/, '');
    const url = `${this.envService.baseUrl}/guest/estimate/${cleanShortKey}/pdf`;

    const body = {
      dob,
      zipCode,
    };

    return this.http.post(url, body, {
      responseType: 'blob',
    });
  }
}
